import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

function NavBarDropdown({ text, tip, icon = null, options = [] }) {
  const [open, setOpen] = useState(false);
  const [mouseOver, setMouseOver] = useState(false);
  const navigate = useNavigate();
    console.log(open)
  return (
    <li
      style={{
        position: "relative",
        paddingBottom: 11,
        paddingTop: 13,
      }}
      className="navbar-list"
    >
      <button
        //href="#"
        className="drop-down-navbar"
        style={{
          backgroundColor: "rgb(23, 55, 151, 0.0)",
          border: "none",
          color: "white",
          textDecoration: "none",
          pointerEvents: "auto",
        }}
         onClick={() => setOpen(!open)}
         onMouseOver={() => setMouseOver(true)}
  onMouseLeave={() => setMouseOver(false)}
      >
        <nobr>
          {icon && <FontAwesomeIcon icon={icon} />}{" "}
          <span className="hide-on-mobile">{text}</span>
        </nobr>
      </button>
      {open && (
        <div
          className="dropdown-navbar-menu"       
        >
          {options.map((opt, idx) => (
            <a
              key={idx}
              href={opt.route}
              onClick={() => {setOpen(false)}}
              className="dropdown-navbar-option"          
            >
              {opt.text}
            </a>
          ))}
        </div>
      )}
      {tip && mouseOver && (
        <div className="tips-navbar" style={{ position: "absolute" }}>
          {tip}
        </div>
      )}
    </li>
  );
}

export default NavBarDropdown;